import React, { useEffect, useRef, useState } from "react"
import Swiper, { Navigation } from "swiper"
import {
  API_ENDPOINTS,
  RUNMODE,
  SWIPER_OPTIONS,
  TOPIC_IMAGE_BASE_URL,
  TOPIC_IMAGE_RESOLUTION,
} from "../../../constants/constants"
import fetchData from "../../../service/apiService"
import { replaceCharacterInString } from "../../../utils/utils"
import "./TopicsList.css"
Swiper.use([Navigation])

const TopicsList = (props) => {
  const {
    id,
    title,
    endpointList,
    target,
    apikey,
    runMode,
    redirectURLAuthor,
    redirectURLPublish,
    searchListingRedirectionUrlAuthor,
    searchListingRedirectionUrlPublish,
  } = props
  const [topicsData, setTopicsData] = useState([])
  // const topicsSwiper = useRef(null)

  useEffect(() => {
    const fetchTopicsData = async () => {
      try {
        const endpoint = endpointList?.find(
          (endpoint) => endpoint.endpointLabel === API_ENDPOINTS.METADATA_TOPIC
        ).apiEndpoint
        const headers = {
          apikey: apikey,
        }
        const data = await fetchData(endpoint, "", null, headers)
        setTopicsData(data)
      } catch (error) { }
    }
    fetchTopicsData()
  }, [])

  // useEffect(() => {
  //   topicsSwiper.current = new Swiper(".topicsSwiper", SWIPER_OPTIONS)
  //   // Destroy the Swiper instance when the component unmounts
  //   return () => {
  //     if (topicsSwiper?.current) {
  //       topicsSwiper?.current?.destroy()
  //     }
  //   }
  // }, [])

  return (
    <>
      <section>
        <div>
          <div className="aem-Grid ">
            <div className="title page-title">
              <div className="cmp-title">
                <h1 className="cmp-title__text">{title}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id={id}>
        <div>
          <div className=" topicSwiper">
            <div className="aem-Grid  ">
              {topicsData?.efitopics
                ?.filter((t) => t.level === 1)
                ?.sort((a, b) => a.order - b.order)
                ?.map((topic, index) => {
                  let imageUrl = `${TOPIC_IMAGE_BASE_URL}${topic.id}${TOPIC_IMAGE_RESOLUTION}`
                  if (!imageUrl.includes("qlt=")) {
                    imageUrl += `?qlt=85&resMode=sharp2`
                  }
                  return (
                    <div
                      key={index}
                      className=" topics-card-hr topics-card-text-hr card-spacing-sm aem-GridColumn--default--6 aem-GridColumn--desktop--6 aem-GridColumn--tablet--6 aem-GridColumn--phone--12 "
                    >
                      <div className="card-wrapper">
                        <div className="card-content">
                          <div className="cmp-teaser__image">
                            <div className="cmp-image">
                              <img
                                src={imageUrl}
                                className="cmp-image__image"
                                loading="lazy"
                                alt={topic?.topic}
                                title={topic?.topic}
                              />
                            </div>
                          </div>
                          <div className="cmp-teaser__content">
                            <div className="topics-card-top-content">
                              <div className="card-title">
                                <h2 className="card-title-text">
                                  <a
                                    href={`${runMode === RUNMODE.AUTHOR
                                      ? redirectURLAuthor
                                      : redirectURLPublish
                                      }${runMode === RUNMODE.AUTHOR ? "." : "/"
                                      }${replaceCharacterInString(
                                        topic.id,
                                        ".",
                                        "+"
                                      )}${runMode === RUNMODE.AUTHOR ? ".html" : ""
                                      }`}
                                    target={target}
                                  >
                                    {topic.topic}
                                  </a>
                                </h2>
                              </div>
                              <ul className="card-link-list">
                                {topicsData?.efitopics
                                  ?.filter((tpd) => tpd.level === 2)
                                  .filter(
                                    (tp) => tp.id.split(".")[0] === topic.id
                                  )
                                  ?.sort((a, b) => a.order - b.order)
                                  .map((subtopic, index) => (
                                    <li
                                      key={index}
                                      className="card-link-list-item"
                                    >
                                      <a
                                        href={`${runMode === RUNMODE.AUTHOR
                                          ? redirectURLAuthor
                                          : redirectURLPublish
                                          }${runMode === RUNMODE.AUTHOR ? "." : "/"
                                          }${replaceCharacterInString(
                                            subtopic.id,
                                            ".",
                                            "+"
                                          )}${runMode === RUNMODE.AUTHOR
                                            ? ".html"
                                            : ""
                                          }`}
                                        className="card-list-link-text"
                                        target={target}
                                      >
                                        {subtopic.topic}{" "}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                            <div className="card-data">
                              <div className="card-data-item">
                                <p className="card-data-title">Indicators</p>
                                <p className="card-data-value">
                                  <a
                                    href={`${runMode === RUNMODE.AUTHOR
                                      ? searchListingRedirectionUrlAuthor
                                      : searchListingRedirectionUrlPublish
                                      }${runMode === RUNMODE.AUTHOR ? ".html" : ""
                                      }?topicId=${topic.id}&type=Indicator`}
                                  >
                                    {topic.indicators}
                                  </a>
                                </p>
                              </div>
                              <div className="card-data-item">
                                <p className="card-data-title">Datasets</p>
                                <p className="card-data-value">
                                  <a
                                    href={`${runMode === RUNMODE.AUTHOR
                                      ? searchListingRedirectionUrlAuthor
                                      : searchListingRedirectionUrlPublish
                                      }${runMode === RUNMODE.AUTHOR ? ".html" : ""
                                      }?topicId=${topic.id}&type=Dataset`}
                                  >
                                    {topic.datasets}
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
            {/* <div
              className="swiper-button-next"
              tabIndex="-1"
              aria-hidden="true"
              aria-disabled="true"
            ></div>
            <div
              className="swiper-button-prev"
              tabIndex="-1"
              aria-hidden="true"
              aria-disabled="true"
            ></div> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default TopicsList
